<!--
 * @Author: CaoJianBo
 * @Date: 2023-07-17 15:28:53
 * @LastEditors: caojianbo 535916207@qq.com
 * @LastEditTime: 2025-09-28 18:35:01
 * @FilePath: \fe-crm\src\views\leads\components\clue-conversion\index.vue
-->
<template>
  <div class="page-comp-clue-conversion">
    <jw-modal :visible="data.visible" @ok="handleOk" @cancel="handleCancel" :okText="$t('下一步')" :cancelText="$t('取消')" unmountOnClose :title="$t('转化')" titleAlign="start" class="clue-conversion-modal" :ok-loading="loading">
      <div class="client-opportunity">
        <div class="client-opportunity-icon hand" @click="opChange(0)" :class="{ 'active-icon': !data.opSwitch }">
          <qf-icon-transfer-client width="60px" height="60px" :color="!data.opSwitch ? '#3472FF' : '#87909D'" />
          <span class="client-opportunity-icon-text">{{ $t('转化为') }}{{ data.customerObjectName || $t('客户') }}</span>
        </div>
        <div class="client-opportunity-icon hand" @click="opChange(1)" :class="{ 'active-icon': data.opSwitch, 'op-disabled': data.msqlTaskId }" :title="data.msqlTaskId ? $t('apass导入的线索不能转化为商机') : ''">
          <qf-icon-transfer-opportunity width="60px" height="60px" :color="data.opSwitch ? '#3472FF' : '#87909D'" />
          <span class="client-opportunity-icon-text">
            {{ $t('转化为') }}
            {{ data.customerObjectName || $t('客户') }}
            {{ data.opportunityObjectName || $t('商机') }}
          </span>
        </div>
      </div>
      <div class="select-view" v-show="!grayList?.['Layout:viewInit']">
        <div class="select-content">
          <span class="title">{{ data.customerObjectName || $t('客户') }}{{ $t('视图') }}:</span>
          <jw-select :trigger-props="{ updateAtScroll: true }" v-model="data.customerViewId" :placeholder="$t('请选择视图')" class="system-form-item-fields" :options="data.viewCustomerList" allow-search> </jw-select>
        </div>
        <div class="select-content" v-if="data.opSwitch">
          <span class="title">{{ data.opportunityObjectName || $t('商机') }}{{ $t('视图') }}:</span>
          <jw-select :trigger-props="{ updateAtScroll: true }" v-model="data.opportunityViewId" :placeholder="$t('请选择视图')" class="system-form-item-fields" :options="data.viewOpportunityList" allow-search> </jw-select>
        </div>
      </div>
      <div class="clue-conversion-tip">
        <p>{{ $t('提醒') }}：{{ $t('tips.synchronous') }}</p>
      </div>
    </jw-modal>
  </div>
</template>

<script setup>
import { inject, reactive } from 'vue';
import useLoading from '@/hooks/loading';
import { useRouter } from 'vue-router';
import { Message } from '@arco-design/web-vue';
import { layoutService, setService } from '@/api/';
import { useGrayscaleStore } from '@/store';
const { grayList } = useGrayscaleStore(); //用户信息
const data = reactive({
  viewCustomerList: [],
  viewOpportunityList: [],
  customerViewId: null,
  opportunityViewId: null,
  visible: false,
  opSwitch: 0,
  id: inject('detailParams')?.id || inject('defaultParams')?.id,
  sourceFrom: inject('detailParams')?.sourceFrom,
  msqlTaskId: inject('msqlTaskId')?.id,
  entity: inject('detailParams')?.entity || inject('defaultParams')?.entity,
  customerObjectName: '',
  opportunityObjectName: ''
});
const { loading, setLoading } = useLoading(true);
const router = useRouter();
const open = () => {
  data.visible = true;
  data.opSwitch = 0;
  getView(2);
  getRuleObjList();
};
const getRuleObjList = async () => {
  try {
    const res = await setService.getRuleObjList({});
    if (!res.error) {
      res.result.map((v) => {
        if (v.value == 2) {
          data.customerObjectName = v.label;
        }
        if (v.value == 3) {
          data.opportunityObjectName = v.label;
        }
      });
    }
  } catch (e) {
    console.log(e);
  }
};
const handleCancel = () => {
  data.visible = false;
};
const handleOk = () => {
  data.visible = false;
  let businessId = null;
  if (!data.opSwitch) {
    businessId = data.customerViewId;
  } else {
    businessId = data.customerViewId + '&' + data.opportunityViewId;
  }
  // 处理 opSwitch：null/undefined/空字符串 都转为 0
  const newOpSwitch = (data.opSwitch ?? '') === '' ? 0 : data.opSwitch;
  router.push({
    name: 'conversion',
    params: { id: data.id, opSwitch: newOpSwitch, businessId, entity: data.entity }
  });
};
//获取对象下的视图
const getView = async (entity) => {
  setLoading(true);
  try {
    const json = await layoutService.getObjectView({ entity: entity });
    if (json?.error) {
      Message.error(json?.error?.msg || '操作失败');
      setLoading(false);
      return;
    } else {
      data.viewList = json?.result;
      if (entity === 2) {
        //过滤30外链类型
        data.viewCustomerList = data.viewList
          ?.filter((vl) => vl?.type != '30')
          ?.map((item) => {
            return { label: item.name, value: item.id };
          });
        if (data.viewCustomerList.length > 0) {
          data.customerViewId = data.viewCustomerList[0].value;
        }
      } else {
        //过滤30外链类型
        data.viewOpportunityList = data.viewList
          ?.filter((vl) => vl?.type != '30')
          ?.map((item) => {
            return { label: item.name, value: item.id };
          });
        if (data.viewOpportunityList.length > 0) {
          data.opportunityViewId = data.viewOpportunityList[0].value;
        }
      }
    }
    setLoading(false);
  } catch (e) {
    setLoading(false);
    Message.error(e.msg || e.statusText || '操作失败');
  }
};
// 切换开关--是否选择转化商机
const opChange = (value) => {
  console.log(52, value);
  if (data.msqlTaskId) return;
  data.opSwitch = value;
  if (value) {
    getView(3);
  }
};
defineExpose({ open });
</script>
<style scoped lang="less">
@import './index.less';
</style>
